import React from 'react';
import cartReducer, {defaultState} from "./cart-reducer";
import actions from './cart';

const CartContext = React.createContext();

function useCartContextValue() {

    const [state, dispatch] = React.useReducer(cartReducer, defaultState);

    const {cart} = state;

    const addToCart = React.useCallback((item) => dispatch(actions.addToCart(item)), []);
    const removeFromCart = React.useCallback((id) => dispatch(actions.removeFromCart(id)), []);

    function reducer(previous, current, index, array) {

        const returns = previous + current.price;
        console.log(`previous: ${previous}, current: ${current}, index: ${index}, returns: ${returns}`);
        return returns;
    }

    function getTotal() {


        if(cart.length > 0) {
            let counts = 0;
            cart.forEach((cartItem) => counts += cartItem.price * cartItem.amount);
            return counts;
        } else {
            return 0;
        }
    }

    return React.useMemo(() => {
        return {
            cart,
            addToCart, removeFromCart,
            getTotal,
        }
    }, [
        cart,
        addToCart,removeFromCart,
        getTotal,
    ]);
}

function CartProvider(props) {
    const value = useCartContextValue();
    return <CartContext.Provider value={value} {...props} />
}

function useCart() {
    const context = React.useContext(CartContext);
    if(!context) {
        throw new Error("useCart must me used within a CartProvider");
    }
    return context;
}

export {
    CartProvider,
    useCart,
}